
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3084"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3084"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("4nyqO", function(module, exports) {

$parcel$export(module.exports, "register", () => $330404c899e35e90$export$6503ec6e8aabbaf, (v) => $330404c899e35e90$export$6503ec6e8aabbaf = v);
var $330404c899e35e90$export$6503ec6e8aabbaf;
var $330404c899e35e90$export$f7ad0328861e2f03;
"use strict";
var $330404c899e35e90$var$mapping = new Map();
function $330404c899e35e90$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$330404c899e35e90$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $330404c899e35e90$var$resolve(id) {
    var resolved = $330404c899e35e90$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$330404c899e35e90$export$6503ec6e8aabbaf = $330404c899e35e90$var$register;
$330404c899e35e90$export$f7ad0328861e2f03 = $330404c899e35e90$var$resolve;

});

var $faf3cb79d23b82c5$exports = {};

(parcelRequire("4nyqO")).register(new URL("", import.meta.url).toString(), JSON.parse('["aT88m","index.3e438a31.js","9yzVh","logo.ee0d4271.webp","e2v3u","model.a970a462.webp","8rDaM","model-trp.e8f8912b.webp","cDRUh","index.b4a108fc.css"]'));


//# sourceMappingURL=index.runtime.7922d72a.js.map
